import React, { useEffect, useState, useRef } from 'react'
import { Table, Modal, Spin, Button } from 'antd';
import { Editor } from '@tinymce/tinymce-react'; // Import TinyMCE
import { sendNotify } from '../helper/notification'
import HomeRep from '../repository/homeRep'
import { API_BASE_URL } from '../helper'
import axios from 'axios'

export default function Resources() {
  const uploader = useRef();
  const editorRef = useRef(null);

  const { confirm } = Modal;
  const [loading, setLoading] = useState(false)
  const [list, setList] = useState([])
  const [title, setTitle] = useState('')
  const [formData, setFormData] = useState({})
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [mode, setMode] = useState('Add')
  const [description, setDescription] = useState('')
  const [documents, setDocuments] = useState([]);
  const [shortDes, setShortDes] = useState('')

  useEffect(() => {
    getResources()
  }, []);

  const columns = [
    {
      title: 'S.No',
      dataIndex: 'key',
    },
    {
      title: 'Media',
      dataIndex: 'images',
      render: (_, { image }) => {
        const src = image?.startsWith('data:') ? image : `data:image/jpeg;base64,${image}`;
        return <img src={src} alt="" width="150" height="150" className='img-fluid' style={{ objectFit: 'cover', borderRadius: '8px' }} />;
      },
    },
    {
      title: 'Title',
      dataIndex: 'title'
    },
    {
      title: 'Short Description',
      dataIndex: 'short_des',
      render: (_, { short_des }) => {
        const text = (short_des || '').slice(0, 100) + (short_des?.length > 100 ? "..." : "");
        return <div>{text}</div>;
      }
    },
    {
      title: 'Actions',
      dataIndex: 'actions',
      render: (_, { actions }) => (
        <div className='d-flex'>
          <button className='btn' onClick={() => openModal(actions, "Edit")}>
            <i className="far fa-edit fa-lg" style={{ color: "#0083ff" }}></i>
          </button>
          <button className='btn' onClick={() => confrimDelete(actions._id)}>
            <i className="fas fa-trash fa-lg" style={{ color: "#ff0000" }}></i>
          </button>
        </div>
      ),
    },
  ];

  const getResources = () => {
    setLoading(true)
    HomeRep.getResourcesList().then(response => {
      setLoading(false)
      if (response) {
        if (response?.error || response.status_code !== 200) {
          sendNotify('error', response.message || 'Failed to fetch Data')
          setList([])
        } else {
          let data = response?.data?.map((data, i) => (
            {
              key: i + 1,
              image: data?.image_url,
              title: data?.title,
              short_des: data?.short_des,
              pos: data?.position,
              description: data?.description,
              actions: data
            }
          ))
          setList(data)
        }
      }
    }).catch(error => {
      sendNotify('error', 'Failed to fetch Data')
      setLoading(false)
    })
  }

  const openModal = (data, mode) => {
    setMode(mode);
    if (mode === "Edit" && data) {
      setTitle(data.title || '');
      setShortDes(data.short_des || '');
      setDescription(data.description || '');
      const src = data.image_url?.startsWith('data:') ? data.image_url : `data:image/jpeg;base64,${data.image_url}`;
      setDocuments([{ name: "Existing Image", base64: src }]);
      setFormData(data);
    } else {
      setTitle('');
      setShortDes('');
      setDescription('');
      setDocuments([]);
      setFormData({});
    }
    setIsModalOpen(true);
  };

  function getBase64(file) {
    return new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onload = () => resolve(reader.result);
      reader.onerror = error => reject(error);
    });
  }

  const onFileUpload = async (e) => {
    let files = Array.from(e.target.files);
    handleFiles(files);
  };

  const handleFiles = async (files) => {
    if (files.length === 0) return;
    
    let file = files[0]; // Only one image allowed
    if (!file.type.startsWith('image/')) {
        sendNotify("error", `File ${file.name} is not an image!`);
        return;
    }
    if (file?.size > 5242880) {
      sendNotify("error", `File ${file.name} is too big! Upload below 5MB.`);
      return;
    }
    
    const base64 = await getBase64(file);
    setDocuments([{ name: file.name, base64: base64, file: file }]); // Replace existing
  }

  const handleDrop = (e) => {
    e.preventDefault();
    const files = Array.from(e.dataTransfer.files);
    handleFiles(files);
  };

  const handleDragOver = (e) => {
    e.preventDefault();
  };

  const handleOk = async () => {
    const currentDescription = editorRef.current ? editorRef.current.getContent() : description;

    if (documents.length === 0 && mode === 'Add') {
      sendNotify('error', 'Please upload an image');
      return;
    }
    if (!title || !shortDes || !currentDescription) {
        sendNotify('error', 'Please fill all required fields');
        return;
    }

    const payload = new FormData();
    payload.append('title', title);
    payload.append('description', currentDescription);
    payload.append('short_des', shortDes);

    if (mode === 'Edit') {
      payload.append('id', formData._id);
    }

    documents.forEach(doc => {
      if (doc.file) {
        payload.append('image', doc.file);
      }
    });

    HomeRep.addResources(payload)
      .then((response) => {
        if (response?.error || response.status_code !== 200) {
          sendNotify('error', response.message || 'Failed to update resource');
        } else {
          setIsModalOpen(false);
          getResources();
          sendNotify('success', response.message || 'Resource saved successfully');
          setDocuments([]);
        }
      })
      .catch((error) => {
        sendNotify('error', 'Failed to update resource');
      });
  };

  const handleCancel = () => {
    setIsModalOpen(false);
    setDocuments([])
  };

  const removeFile = (index) => {
    const newDocs = [...documents];
    newDocs.splice(index, 1);
    setDocuments(newDocs);
  };

  const confrimDelete = (id) => {
    confirm({
      title: <h5>Confirm Delete</h5>,
      content: <p>Are you sure you want Delete?</p>,
      className: 'custom-confirm',
      centered: true,
      okText: 'Delete',
      onOk() {
        deleteRecord(id);
      },
    });
  };

  const deleteRecord = (id) => {
    setLoading(true)
    HomeRep.deleteResources(id).then(response => {
      if (response) {
        if (response?.error || response.status_code !== 200) {
          sendNotify('error', response.message || 'Failed to delete data')
          setLoading(false)
        } else {
          sendNotify('success', response.message || 'Deleted successfully')
          getResources() // Refetch data
          setTimeout(() => {
            window.location.reload();
          }, 500);
        }
      }
    }).catch(error => {
      sendNotify('error', 'An error occurred during deletion')
      setLoading(false)
    })
  }

  return (
    <section className='mt-md-3'>
      <div className="page-header flex-md-row flex-column">
        <h1>Resources</h1>
        <button className="primary-btn" onClick={() => openModal(null, "Add")}><i className="fas fa-plus"></i> Add Resource</button>
      </div>

      <Table columns={columns} dataSource={list} loading={loading} pagination={{ className: 'custom-pagination' }} className='custom-table' />
      <div>
        <Modal 
            title={mode === 'Add' ? 'Add Resource' : 'Edit Resource'} 
            className='custom-modal' 
            open={isModalOpen} 
            onCancel={handleCancel}
            footer={[
                <Button key="cancel" onClick={handleCancel}>Cancel</Button>,
                <Button key="ok" type="primary" onClick={handleOk}>OK</Button>
            ]}
        >
          <Spin spinning={false}>
            <>
              <div 
                className="custom-dragger p-0 w-100" 
                style={{
                    border: '2px dashed #aaa',
                    borderRadius: '16px',
                    textAlign: 'center',
                    cursor: 'pointer',
                    minHeight: '120px',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    background: '#fafbfc',
                    marginBottom: '16px'
                }}
                onClick={() => uploader.current.click()}
                onDrop={handleDrop}
                onDragOver={handleDragOver}
              >
                <input type="file" accept="image/*" ref={uploader} onChange={onFileUpload} className="d-none" />
                {documents.length > 0 ? (
                  <div className="d-flex flex-wrap gap-2 justify-content-center p-3">
                    {documents.map((doc, index) => (
                      <div key={index} style={{ position: 'relative' }}>
                        <img src={doc.base64} alt="Uploaded" width="100" height="100" style={{ objectFit: 'cover', borderRadius: '8px' }} />
                        <span 
                          onClick={(e) => { e.stopPropagation(); removeFile(index); }} 
                          style={{ position: 'absolute', top: -5, right: -5, background: 'red', color: 'white', borderRadius: '50%', width: 20, height: 20, display: 'flex', alignItems: 'center', justifyCenter: 'center', cursor: 'pointer', fontSize: 12 }}
                        >x</span>
                      </div>
                    ))}
                  </div>
                ) : (
                  <div>
                    <p style={{ color: '#888', margin: 0 }}>Click or drag & drop to upload Image</p>
                  </div>
                )}
              </div>

              <div className='input-box req mt-4'>
                <label htmlFor="title">Title <span style={{color: 'red'}}>*</span></label>
                <div className='input-field'>
                  <input
                    type="text"
                    name="title"
                    id="title"
                    value={title}
                    placeholder="Title"
                    onChange={(e) => setTitle(e.target.value)}
                  />
                </div>
              </div>
              <div className='input-box req mt-4'>
                <label htmlFor="shortDes">Short Description <span style={{color: 'red'}}>*</span></label>
                <div className='input-field'>
                  <input
                    type="text"
                    name="shortDes"
                    id="shortDes"
                    value={shortDes}
                    placeholder="Short Description"
                    onChange={(e) => setShortDes(e.target.value)}
                  />
                </div>
              </div>
              <div className='input-box req mt-4'>
                <label>Description <span style={{color: 'red'}}>*</span></label>
                <Editor
                  apiKey="antv4ukg290u4dj9t7swphwv1ydynummcqyrqjbc8mty25d5"
                  onInit={(evt, editor) => editorRef.current = editor}
                  value={description}
                  onEditorChange={(content) => setDescription(content)}
                  init={{
                    height: 250,
                    menubar: false,
                    plugins: [
                      'advlist', 'autolink', 'link', 'image', 'lists', 'charmap', 'preview', 'anchor', 'pagebreak',
                      'searchreplace', 'wordcount', 'visualblocks', 'visualchars', 'code', 'fullscreen', 'insertdatetime',
                      'media', 'table', 'emoticons', 'help'
                    ],
                    toolbar: 'undo redo | styles | bold italic | alignleft aligncenter alignright alignjustify | bullist numlist outdent indent | link image |  forecolor backcolor emoticons',
                    automatic_uploads: true,
                    images_upload_handler: (blobInfo, progress) => new Promise((resolve, reject) => {
                      const formData = new FormData();
                      formData.append('file', blobInfo.blob(), blobInfo.filename());

                      let local = localStorage.getItem(process.env.REACT_APP_JWT_TOKEN);
                      let details = local ? JSON.parse(local) : null;
                      let token = details?.tokenObj?.accessToken;

                      const uploadUrl = API_BASE_URL ? `${API_BASE_URL}/api/home/upload` : '/api/home/upload';

                      axios.post(uploadUrl, formData, {
                        onUploadProgress: (e) => {
                          progress(Math.round((e.loaded / e.total) * 100));
                        },
                        headers: {
                          'Content-Type': 'multipart/form-data',
                          'Authorization': token
                        }
                      })
                      .then(response => {
                        if (response.data && response.data.location) {
                          resolve(response.data.location);
                        } else {
                          reject('Invalid response from server');
                        }
                      })
                      .catch(error => {
                        reject('HTTP Error: ' + (error.response?.data?.error || error.message));
                      });
                    })
                  }}
                />
              </div>
            </>
          </Spin>
        </Modal>
      </div>
    </section>
  )
}
